module.exports = __webpack_public_path__ + "static/media/07n.252fd33d.svg";